<template>
  <section>
    <div class="wdt" style="height: 500px; margin: auto; margin-top: 10%">
      <div v-if="loading" style="text-align: center;">
        <p class="is-size-4">
          Collecting information on your meeting...
        </p>
        <div class="container" style="width: 100%; height: 80%">
          <b-loading :is-full-page="false" :active="true"></b-loading>
        </div>
      </div>
      <div v-else style="margin: auto;">
        <div class="tile is-parent is-vertical centered field">
          <b-field label="Meeting Registration Code">
            <b-input
              v-model="meeting_code"
              @keyup.native.enter="checkAuthenticate"
              name="email"
            ></b-input>
          </b-field>
          <b-field label="Attendee Email">
            <b-input
              v-model="attendee_email"
              @keyup.native.enter="checkAuthenticate"
              name="email"
            ></b-input>
          </b-field>
          <b-field label="Attendee Access Code">
            <b-input
              v-model="access_code"
              @keyup.native.enter="checkAuthenticate"
              name="password"
            >
            </b-input>
          </b-field>
          <b-message
            v-if="wrong"
            type="is-danger"
            aria-close-label="Close message"
          >
            Meeting or access code invalid
          </b-message>
          <b-button
            size="is-medium"
            type="is-gant"
            class="ubuntu"
            @click="authenticate"
            expanded
          >
            <h5>Proceed</h5>
          </b-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Authorization",
  data: function() {
    return {
      logged_in: false,
      email: "",
      password: "",
      access_token: "",
      wrong: false,
      loading: true,
      access_code: this.$route.query.access_code,
      meeting_code: this.$route.query.meeting_code,
      attendee_email: this.$route.query.email,
      result: {},
    };
  },
  watch: {
    currentTravellerProfile(newVal, prevVal) {
      // console.log('prevVal:', JSON.stringify(prevVal));
      // console.log('newVal:', JSON.stringify(newVal));
      if (this.currentTravellerProfile?.unusedTicketAirlines) {
        this.$emit("authorized");

      }
    },
  },
  computed: {
    currentTravellerProfile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    },
    accessCode() {
      if (this.$route.query.access_code) {
        return this.$route.query.access_code;
      } else {
        return this.access_code;
      }
    },
    meetingCode() {
      if (this.$route.query.meeting_code) {
        return this.$route.query.meeting_code;
      } else {
        return this.meeting_code;
      }
    },
    attendeeEmail() {
      if (this.$route.query.email) {
        return this.$route.query.email;
      } else {
        return this.attendee_email;
      }
    },
  },
  methods: {
    checkAuthenticate() {
      // await this.setTravellers()
      if (this.accessCode && this.meetingCode && this.attendeeEmail) {
        this.loading = true;
        this.authenticate();
      } else {
        this.loading = false;
      }
    },
    setTravellers() {
      if (!this.$globals.currentTravellerProfile.email) {
        let travellers = {
          tripType: "business",
          bookFor: "user",
          others: [],
          set: true,
          business: true,
          self: true,
        };
        this.$store.commit("travellersAndTrips/EDIT_TRAVELLERS", travellers);
      }
    },
    async authenticate() {
      var raw = {
        email: this.attendeeEmail,
        attendeeAccessCode: this.accessCode,
        meetingRegistrationCode: this.meetingCode,
      };

      this.$app
        .huddleLabsServerCall("meetings/attendee/auth", raw)
        .then((result) => {
          if (result.error || result.errors) {
            this.wrong = true;
            this.loading = false;
            console.log("auth error");
          } else {
            console.log("auth success");
            this.result = result.data;
            this.result.optOutFlight = false;
            this.result.optOutCar = false;
            this.result.optOutHotel = false;
            this.proceed();
          }
        });
    },
    async proceed() {
      await this.getAdditionalProfileData();
      await this.$store.dispatch("meetings/addMeeting", this.result);
      if (!this.result.meeting.survey) {
        await this.$store.commit("meetings/MEETING_SURVEY_SET", true);
      }
    },
    getAdditionalProfileData() {
      this.getProfile();
      // this.getUnusedTickets(raw)
      // this.getPaymentMethods(raw)
      // Get details about airline unaccompanied minors programs
      this.$app
        .huddleLabsServerCall("resources/airline-unaccompanied-minors")
        .then((result) => {
          this.$store.commit(
            "travellersAndTrips/UNACCOMPANIED_MINOR_AIRLINE_DETAILS",
            result.data
          );
        });
    },
    getProfile() {
      var raw = {
        contactId: this.result.contactId,
        includeRelated: [
          "travelerPrograms",
          "paymentMethods",
          "unusedTickets",
          "travelPolicy",
          "preferredVendors",
        ],
      };
      this.$app
        .huddleLabsServerCall("profile/travel-profile", raw)
        .then((result) => {
          this.$store.commit("meetings/ADD_MEETING_PROFILE", result.data); // console.log(result.data);
          //set current traveller profile = meeting contact
          this.$store.dispatch("travellersAndTrips/addMeetingContactToProfile");
        });
    },
    setRegistrationTime() {
      var raw = {
        id: this.result.attendeeId,
        events: ["registrationStarted"],
      };
      this.$app.huddleLabsServerCall("meetings/attendee/save", raw);
    },
  },
  mounted() {
    this.checkAuthenticate();
    this.$store.commit("meetings/MEETING_PROFILE_SET", false);
    this.$store.commit("meetings/MEETING_SURVEY_SET", false);
    //this.$store.dispatch("travellersAndTrips/addMeetingContactToProfile");
  },
};
</script>

<style scoped>
.image {
  padding: 15px;
  padding-right: 20px;
}
.trip {
  color: #292c58;
  font-family: Krungthep;
  font-size: 50px;
}
.circuit {
  color: #00aa9c;
  font-family: Krungthep;
  font-size: 50px;
}
.text-center {
  text-align: center;
}
.centered {
  margin: auto;
}
.field {
  border-radius: 5px;
}
.wdt {
  width: 500px;
  margin: auto;
  /* background-color: #F5F0E1; */
}
.register {
  background-color: #ddd;
  /* background-color: #F5F0E1; */
  border-radius: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.conditions {
  font-size: 13px;
  color: #292c58;
}
.btn {
  background-color: #292c58;
}
.shdw {
  box-shadow: 0 2px 4px 0 rgba(245, 240, 225, 0.8),
    0 6px 20px 0 rgba(245, 240, 225, 0.8);
  border-radius: 5px;
}
.fade {
  opacity: 0.5;
  transition: opacity 0.05s ease-in-out;
  -moz-transition: opacity 0.05s ease-in-out;
  -webkit-transition: opacity 0.05s ease-in-out;
}
.fade:hover {
  opacity: 1;
}
@media screen and (max-width: 1023px) {
  .wdt {
    width: 100%;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}
@media screen and (min-width: 1024px) {
  .wdt {
    width: 500px;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}
</style>
<style scoped lang="scss">
$loading-icon-size: 5em;
</style>
